<template>
  <div class="download-version">
    <div class="tog tog--download-version top-bar" @click="showVersion=!showVersion">
      <div class="top-bar--left">
        <div class="version-inf">
          <font-awesome-icon icon="caret-right" v-if="!showVersion"></font-awesome-icon>
          <font-awesome-icon icon="caret-down" v-else></font-awesome-icon>
          Version {{versionData.ver}}
          <span class="text-warning" v-if="versionType==='beta' || versionType==='development'">{{versionData.release_type_name}}</span>
          <span v-else>{{versionData.release_type_name}}</span>
          <span class="testing-info">{{testingTitle}}</span>
        </div>
      </div>
      <div class="top-bar--right">{{versionData.date}}</div>
    </div>
    <b-collapse class="table table--download" v-model="showVersion">
      <b-container fluid>
        <b-row>
          <b-col class="os-version-item">
            <icon-win-os width="150" height="150"></icon-win-os>
            <div class="install-link">
              <a :href="versionData.links.win" target="_blank">Windows Installer</a>
            </div>
            <span class="install-details">
              Windows 7, 8, 8.1, 10
            </span>
          </b-col>
          <b-col class="os-version-item" v-if="versionData.links.mac">
            <icon-mac-os width="150" height="150"></icon-mac-os>
            <div class="install-link">
              <a :href="versionData.links.mac" target="_blank">Apple disk image</a>
            </div>
            <span class="install-details">
              Mac OS X 10.10.2+
            </span>
            <div class="install-instructions">
              <a href="javascript:void(0)" :id="'mac-instruction' + versionType">Please read</a>
              <b-popover :target="'mac-instruction' + versionType" placement="bottom" :triggers="['click', 'blur']">
                <p>
                  There is no stable MAC version due to OS X limitations, if you still need one, please contact support.
                </p>
              </b-popover>
            </div>
          </b-col>
          <b-col class="os-version-item">
            <icon-ubuntu-os width="150" height="150"></icon-ubuntu-os>
            <div class="install-link">
              <a :href="versionData.links.ubuntu" target="_blank">.deb Package</a>
            </div>
            <span class="install-details">
              Ubuntu 14.04+
            </span>
          </b-col>
          <b-col class="os-version-item">
            <icon-rpi-os width="150" height="150"></icon-rpi-os>
            <div class="install-link">
              <a href="javascript:void(0)" @click="handleOpenRpiGenerateImageModal">REQUEST RASPBERRY PI IMAGE</a>
            </div>
            <span class="install-details">
              Raspberry Pi 2, 3, 4
            </span>
          </b-col>
          <b-col class="os-version-item">
            <icon-rpi-os width="150" height="150"></icon-rpi-os>
            <div class="install-link">
              <a :href="rpiDownloadLink" target="_blank">Generic Raspberry Pi image</a>
            </div>
            <span class="install-details">
              Raspberry Pi 2, 3, 4
            </span>
            <div class="install-instructions">
              <a href="javascript:void(0)" :id="'rpi-instruction' + versionType">Instructions</a>
              <b-popover :target="'rpi-instruction' + versionType" placement="bottom" :triggers="['click', 'blur']">
                <p>
                  It is not tight to your account. You need to login it
                  manually by going to RPi IP address of your local
                  network. Remote assistance is not supported yet.
                  You do not need to wait for an email though.
                  <br>
                  <strong>Login: </strong> <span style="color: #fa1b4b;">root</span>
                  <br>
                  <strong>Password: </strong> <span style="color: #fa1b4b;">3dprinteros</span>
                </p>
              </b-popover>
            </div>
          </b-col>
          <b-col class="os-version-item">
            <icon-archive width="150" height="150"></icon-archive>
            <div class="install-link">
              <a :href="versionData.links.rpi" target="_blank">Zip Archive</a>
            </div>
            <div class="install-instructions">
              <a href="javascript:void(0)" :id="'archive-instruction' + versionType">Installation guide</a>
              <b-popover :target="'archive-instruction' + versionType" placement="bottom" :triggers="['click', 'blur']">
                <p>For 3DPrinterOS you will need following:</p>

                - Python <span v-if="isPython3Required">3.6+</span><span v-else>2.7.6+</span> <br>
                - LibUSB1.0<br>
                - Your 3d printer drivers installed(if you are running Windows)<br>
                - WXwidgets/Rumps(optional, for tray icon on Windows/Mac)<br>
                - Opencv and numpy (optional, for web camera support)<br>
                <p>
                  To run 3DPrinterOS just execute in command line(bash, cmd, whatever):
                  <span v-if="isPython3Required">python3</span><span v-else>python</span> launcher.py
                </p>
              </b-popover>
            </div>
          </b-col>
        </b-row>

        <b-row class="release-notes-row">
          <b-col>
            <b-card>
              <b-card-title>Release notes and bug fixes</b-card-title>
              <b-card-text>
                <p class="release-notes" v-bind:class="{'release-notes-less': !this.showReleaseNotes}" v-html="releaseNotes"></p>
                <p v-if="!showReleaseNotes">...</p>
              </b-card-text>
              <b-card-text class="small text-muted">
                <a href="javascript:void(0)" v-if="!showReleaseNotes" @click="showReleaseNotes=true">Show more</a>
                <a href="javascript:void(0)" v-if="showReleaseNotes" @click="showReleaseNotes=false">Show less</a>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>

    <b-modal v-model="openRpiRequest" title="Rpi Image Settings" modal-class="modal--notes modal--rpi-request" size="lg">
      <p>
        If you would like to connect your Raspberry Pi over WiFi, please fill in the network name and password below.
      </p>
      <div>
        <b-form inline>
          <font-awesome-icon icon="wifi"></font-awesome-icon>
          <label class="sr-only">SSID</label>
          <b-input v-model="rpiSsid" class="inp" placeholder="SSID"></b-input>
          <label class="sr-only">Password (8..63 characters)</label>
          <b-input type="password" v-model="rpiPassword" class="inp" placeholder="Password (8..63 characters)"></b-input>
        </b-form>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="modal__footer--left">
          <b-button variant="-ternary" class="btn--outline" @click="cancel()">
            Close
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" :disabled="rpiImageProcess" @click="handleGenerateRpiImage">Generate Image</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Vue from "vue";
  import {mapActions} from "vuex";

  import IconWinOs from "../icons/IconWinOs";
  import IconMacOs from "../icons/IconMacOs";
  import IconUbuntuOs from "../icons/IconUbuntuOs";
  import IconRpiOs from "../icons/IconRpiOs";
  import IconArchive from "../icons/IconArchive";

  export default {
    name: 'cloud-client-download-version',
    props: ['versionType', 'versionData'],
    components: {
      IconWinOs,
      IconMacOs,
      IconUbuntuOs,
      IconRpiOs,
      IconArchive
    },
    data() {
      return {
        showVersion: false,
        showReleaseNotes: false,
        openRpiRequest: false,

        rpiSsid: '',
        rpiPassword: '',

        rpiImageProcess: false
      }
    },
    computed: {
      testingTitle() {
        if (this.versionType === 'stable') {
          return '(1000 hours of testing)';
        }

        return '(2+ weeks of testing)';
      },

      rpiDownloadLink() {
        const suffix = !Vue.config.productionTip ? '_acorn.zip' : '.zip';
        const version = this.versionType === 'development' ? 'dev' : this.versionType;

        return "https://builds.3dprinteros.com/3DPrinterOS" + version + suffix;
      },

      releaseNotes() {
        return this.versionData.release_notes.replace(/(?:\r\n|\r|\n)/g, '<br>');
      },

      isPython3Required() {
        return this.versionData.ver[0] >= 7;
      }
    },

    methods: {
      ...mapActions(['requestRpiImage']),

      handleOpenRpiGenerateImageModal() {
        this.openRpiRequest = true;
        this.rpiSsid = '';
        this.rpiPassword = '';
      },

      handleGenerateRpiImage() {
        this.rpiImageProcess = true;
        this.requestRpiImage({
          releaseType: this.versionType,
          ssid: this.rpiSsid,
          password: this.rpiPassword
        }).then(({data}) => {
          this.openRpiRequest = false;
          this.rpiImageProcess = false;
          if (data.result) {
            this.msgBoxOk('Shortly you will receive an email containing the link to your Raspberry Pi Image (takes 5-20m)', {title: 'Request RPi image'});
          } else {
            this.msgBoxOk(data.message, {title: 'Failed to request RPi image'});
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .modal--rpi-request {

    p {
      margin-bottom: 15px;
    }

    .inp, .btn-generate-rpi {
      margin-left: 10px;
    }
  }
</style>
